import StepFlow from '@/febos/chile/approvals/wizardFlow/wizard/flow/StepFlow';
import {
  mapApprovalSteps
} from '@/febos/chile/approvals/wizardFlow/config/wizard/forms/approvalsCommons';

export default () => ({
  currentStep: 0,
  steps: [
    {
      title: 'Enviar documento a flujo',
      component: StepFlow
    }
  ],
  options: ['submit'],
  submitAction: 'sendToFlow',
  loadAllData: false,
  wizardMapper(rawData) {
    const principal = rawData.adjuntos.find((document) => document.tipo === 'principal');
    return {
      fileUrl: principal.adjuntoUrl,
      fileIdFlow: principal.adjuntoId,
      fileNumber: rawData.numero,
      fileType: rawData.tipo,
      fileCategory: rawData.dnt.claseMercadoPublico,
      fileResumen: rawData.dnt.nombreDescriptivo,
      documentType: rawData.dnt.emisorCentroCostoNumero,
      documentGroup: rawData.dnt.solicitanteGrupoId
    };
  },
  documentMapper(input) {
    const data = {
      aprobacionId: input.flowId,
      ejecucion: {
        descripcion: input.description,
        estampar: input.pdfStamp,
        nombre: input.name,
        numero: input.number,
        unidad: input.documentGroup,
        aprobacionesReferenciaId: input.flowId,
        plantilla: {
          aprobaciones: {
            nombre: '',
            descripcion: '',
            estampar: input.pdfStamp,
            foliacion: true,
            tipoejecucion: 'N',
            tipoObjeto: input.typeFlowId,
          },
          ...mapApprovalSteps(input)
        }
      },
      documentos: [
        {
          adjuntoId: input.fileIdFlow,
          adjuntoMime: input.fileMime,
          adjuntoNombre: input.fileName,
          adjuntoUrl: input.fileUrl,
          fecha: input.fileDate,
          objetoId: input.fileId,
          objetoNombre: input.fileName,
          tipoObjetoId: input.typeFlowId,
          tipoObjetoTexto: input.typeFlowText
        }
      ],
      gatillacionesPreDefinidas: [
        '451eeaef-4232-4963-84c8-ccf5366130df',
        'f13b799d-8640-4b42-a1e1-2e9044e038b5',
        '451eeaef-4232-4963-84c8-ccf5366130dr'
      ]
    };

    if (input.isResolution) {
      data.meta = { oficinaAcciones: ['foliar', 'tramitar'] };
    }

    return data;
  }
});
